import { render, staticRenderFns } from "./ChargebackLedgerExplanationModal.vue?vue&type=template&id=3a1b37a2&scoped=true&"
import script from "./ChargebackLedgerExplanationModal.vue?vue&type=script&lang=js&"
export * from "./ChargebackLedgerExplanationModal.vue?vue&type=script&lang=js&"
import style0 from "./ChargebackLedgerExplanationModal.vue?vue&type=style&index=0&id=3a1b37a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b37a2",
  null
  
)

export default component.exports